/**
 * @file コンポーネント：フル動画ページスレッドポップアップ新規作成、編集ページ ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnReplaceLocalizedText,
    fnHandleApiErrors,
} from "~/src/functions/common";

// コンポーネントを返す
export const PopupThreadNewEdit = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    /**
     * 状態管理
     */
    const [errorMessageNewEdit, setErrorMessageNewEdit] = useState(null); // 新規作成、編集ページに表示するエラーメッセージ
    const [isOpenModalThreadConfirm, setIsOpenModalThreadConfirm] = // モーダルの表示非表示
        useState(false);

    /**
     * 要素参照
     */
    const refInputTitle = useRef(null);
    const refTextareaText = useRef(null);

    /**
     * 初期設定
     */
    useEffect(() => {
        // ポップアップ見出し設定
        if (props.currentPage === "new") {
            props.setPopupHeadline(localized["Label.PostANewThread"]);
        } else {
            props.setPopupHeadline(localized["Label.EditThread"]);
        }
        // 編集時：編集対象スレッドの値をフォームに設定
        if (props.currentPage === "edit") {
            refInputTitle.current.value = props.selectedThread.title;
            refTextareaText.current.value = props.selectedThread.context;
        }
    }, []);

    /**
     * メッセージをクリア
     */
    const fnMessageClear = () => {
        setErrorMessageNewEdit(null);
    };

    /**
     * スレッド新規作成、編集
     */
    const fnNewEditThread = (method = "POST") => {
        const context = refTextareaText.current.value;
        const title = refInputTitle.current.value;
        // タイトル、本文の未入力チェック
        if (!context || !title) {
            setErrorMessageNewEdit(localized["Message.ErrorIncomplete"]);
            return;
        }
        // タイトルが128文字以内かチェック
        if (title.length > 128) {
            setErrorMessageNewEdit(
                fnReplaceLocalizedText(
                    localized["ErrorMessage.CharacterOver"],
                    [localized["Label.ThreadTitle"], "128"]
                )
            );
            return;
        }
        // 本文が500文字以内かチェック
        if (context.length > 500) {
            setErrorMessageNewEdit(
                fnReplaceLocalizedText(
                    localized["ErrorMessage.CharacterOver"],
                    [localized["Label.ThreadBody"], "500"]
                )
            );
            return;
        }
        // APIリクエスト
        const id =
            props.currentPage === "new"
                ? props.operationId
                : props.selectedThread.threadId;
        const api = "/api/threads/" + id;
        const token = document
            .getElementById("requestverificationtoken")
            .getAttribute("value");
        const options = {
            body: JSON.stringify({
                context,
                isPublic: true,
                title,
            }),
            headers: {
                "Content-Type": "application/json",
                RequestVerificationToken: token,
            },
            method,
        };
        fetch(api, options)
            .then(fnHandleApiErrors)
            .then((response) => {
                if (response.status === 200) {
                    // selectedthreadを更新
                    props.setSelectedThread({
                        ...props.selectedThread,
                        context,
                        title,
                    });
                    // メッセージをセット
                    props.currentPage === "new"
                        ? props.setMessageList(
                              localized["Message.SuccessPostThread"]
                          )
                        : props.setMessageDetail(
                              localized["Message.SuccessEditThread"]
                          );
                    // ページ遷移
                    props.setCurrentPage(
                        props.currentPage === "new" ? "list" : "detail"
                    );
                }
            })
            .catch((error) => {
                console.error(error);
                setErrorMessageNewEdit(
                    localized[
                        props.currentPage === "new"
                            ? "Message.FailPostThread"
                            : "Message.FailEditThread"
                    ]
                );
            });
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            errorMessageNewEdit={errorMessageNewEdit}
            fnMessageClear={fnMessageClear}
            fnNewEditThread={fnNewEditThread}
            isOpenModalThreadConfirm={isOpenModalThreadConfirm}
            refInputTitle={refInputTitle}
            refTextareaText={refTextareaText}
            setIsOpenModalThreadConfirm={setIsOpenModalThreadConfirm}
        />
    );
};
